import './App.scss';

import {FC} from 'react';

import AppRoute from 'router/AppRoute';
import AppSwitch from 'router/AppSwitch';

import AppLayout from 'layout/AppLayout';

import RouteProvider from 'providers/RouteProvider';
import PageProvider from 'providers/PageProvider';
import ErrorProvider from 'providers/ErrorProvider';

import {Pages} from 'pages';
import {AuthProvider} from "providers/AuthProvider";
import {FilterProvider} from "providers/FilterProvider";
import {history} from "helpers/history";
import {Router} from "react-router-dom";


const App: FC = () => (
    <Router history={history}>
        <ErrorProvider>
            <AuthProvider>
                <RouteProvider>
                    <PageProvider>
                        <FilterProvider>
                            <AppLayout>
                                <AppSwitch>
                                    {[...Pages].map((page) => (
                                        <AppRoute key={page.route.path} {...page.route}>
                                            {page.component}
                                        </AppRoute>
                                    ))}
                                </AppSwitch>
                            </AppLayout>
                        </FilterProvider>
                    </PageProvider>
                </RouteProvider>
            </AuthProvider>
        </ErrorProvider>
    </Router>
);

export default App;
